var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].pageBackground })},[_c('v-main',[(
        _vm.tokenData !== undefined && Object.keys(_vm.toolbarSocketData).length > 0
      )?_c('fixed-toolbar',{attrs:{"toolbarAlarmData":_vm.getToolbarAlarms,"toolbar-socket-data":_vm.toolbarSocketData}}):_vm._e(),_c('router-view',{key:_vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }